<script>
  import { Route, Router } from "svelte-navigator";
  import { userStore } from "./store";
  import {
    AdminOnly,
    Content,
    Footer,
    Header,
    Sidebar,
  } from "./components/index.svelte";
  import {
    PropertyOwnerDashboard,
    SystemAdminDashboard,
    UserList,
    UserDetails,
    UserForm,
    PropertyList,
    PropertyForm,
    PropertyOverview,
    ReservationForm,
    AuthLayout,
    MaintenanceManagement,
    ReportDashboard,
  } from "./views/index.svelte";
  import { fade } from "svelte/transition";

  import { checkIfAdmin } from './helpers/utils.svelte';

  let isAdmin = checkIfAdmin($userStore?.user?.user_type);
</script>

<Router>
  {#if $userStore?.isLoggedIn}
    <Header />
    <Sidebar />
    <Content>
      <Router>
        <Route
          path="/"
          component={isAdmin ? SystemAdminDashboard : PropertyOwnerDashboard}
        />

        <AdminOnly>
          <Route path="/user-management/*">
            <Route path="property-owners">
              <div in:fade>
                <UserList listType="property-owners" />
              </div>
            </Route>
            <AdminOnly requireSuperAdmin={true}>
              <Route path="system-admins">
                <div in:fade>
                  <UserList listType="system-admins" />
                </div>
              </Route>
            </AdminOnly>
            <Route path=":listType/new" let:params>
              <div in:fade>
                <UserForm userType={params.listType} formType="new" />
              </div>
            </Route>
            <Route path=":listType/:userID" let:params>
              <UserDetails userType={params.listType} userID={params.userID} />
            </Route>
            <Route path=":listType/:userID/edit" let:params>
              <div in:fade>
                <UserForm
                  userType={params.listType}
                  userID={params.userID}
                  formType="edit"
                />
              </div>
            </Route>
          </Route>
        </AdminOnly>
        <Route path="/property-management/*">
          <Route path="/">
            <div in:fade>
              <PropertyList />
            </div>
          </Route>
          <Route path="/properties/*">
            <Route path=":propertyID" let:params>
              <div in:fade>
                <PropertyOverview propertyID={params.propertyID} />
              </div>
            </Route>
            <AdminOnly>
              <Route path="new" let:params>
                <div in:fade>
                  <PropertyForm propertyID={params.propertyID} formType="new" />
                </div>
              </Route>
              <Route path=":propertyID/edit" let:params>
                <div in:fade>
                  <PropertyForm
                    propertyID={params.propertyID}
                    formType="edit"
                  />
                </div>
              </Route>
              <Route path=":propertyID/reservations/new" let:params>
                <div in:fade>
                  <ReservationForm
                    propertyID={params.propertyID}
                    formType="new"
                  />
                </div>
              </Route>
              <Route
                path=":propertyID/reservations/:reservationID/edit"
                let:params
              >
                <div in:fade>
                  <ReservationForm
                    reservationID={params.reservationID}
                    propertyID={params.propertyID}
                    formType="edit"
                  />
                </div>
              </Route>
            </AdminOnly>
          </Route>
        </Route>
        <AdminOnly>
          <Route path="/maintenance-management/*">
            <Route path="/">
              <div in:fade>
                <MaintenanceManagement />
              </div>
            </Route>
          </Route>
          <Route path="/reports/*">
            <Route path="/">
              <div in:fade>
                <ReportDashboard />
              </div>
            </Route>
          </Route>
        </AdminOnly>
      </Router>
    </Content>
  {:else}
    <Route path="/">
      <AuthLayout formType="login" />
    </Route>
    <Route path="/forgot-password">
      <AuthLayout formType="forgotPassword" />
    </Route>
    <Route path="/reset-password">
      <AuthLayout formType="resetPassword" />
    </Route>
  {/if}
</Router>
